
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';

/**
 *
 * @class RejectedSelectionBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      May 2021
 *
 */
export class RejectedSelectionBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    return {
      id:          data.id,
      seq:         data.index,
      name:        `${data.text}`,
      hasChildren: false,
      isExpanded:  false,
      type:        'rejected-selection',
      children:    [],
      parent:      args.parent,
      kids:        data.kids,
      tags:        data.tags,
      label:       data.label,
      pkey:        data.pkey,
      text:        data.text,
      u:           data.u,
      follower:           data.follower,
      reason:             data.reason,
      proposedMoveExited: data.proposedMoveExited,
      authByFWD:          data.authByFWD,
      authorities:        data.authorities,
      opposingTrains:     data.opposingTrains
    };

  }
}
